import React, {Component} from 'react';
import {app} from "app/app";
import {Link} from "react-router-dom"
import 'assets/sass/dashboard/deposits/Main.scss';
import {CurrencyCard} from "../common/CurrencyCard";
import DepositAndWithdrawRoutes from "app/routes/DepositAndWithdrawRoutes";
import { AppContext } from 'app/state/AppContext';


export class DepositAndWithdrawHome extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            balances: undefined
        }

        this.handleAccountBalanceResponse = this.handleAccountBalanceResponse.bind(this);
    }

    componentDidMount() {
        app.apiClient().getAccountBalance(this.handleAccountBalanceResponse);
    }

    handleAccountBalanceResponse(response) {
        if (!response.hasError()) {
            this.setState({balances: response.content()});
        }
    }


    actionName() {
        return this.props.action === DepositAndWithdrawRoutes.ACTION_WITHDRAW ? "retirar" : "ingresar";
    }

    getBalance(currency) {
        return this.state.balances ? this.state.balances[currency] : undefined;
    }

    renderLinks() {
        const { currencyCodes } = this.context;
        const currencyDependentRoutes = app.currencyDependentRoutes(currencyCodes);

        return currencyCodes.map(currency => (
            <Link
                to={currencyDependentRoutes.dashboard.depositAndWithdraw[currency][this.props.action]}
                key={currency}>
                <CurrencyCard currency={currency}
                              balance={this.getBalance(currency)}/>
            </Link>
        ));
    }

    render() {
        return (
            <div>
                <h5 className="section-home-title">{`Elegí qué moneda vas a ${this.actionName()}`}</h5>
                <div className="links">
                    {this.renderLinks()}
                </div>
            </div>
        );
    }
}
